/* eslint-disable import/named */
import { ReactNode } from "react";
import {
  toast as reactToast,
  ToastContainer as ReactToastContainer,
  ToastPosition,
  Id,
} from "react-toastify";

import tokens from "../../../theme/tokens";
import { CrossIcon } from "../../atoms/Icons";
import CustomToast from "./CustomToast";
import * as s from "./styles";

export type ToastVariant = "default" | "error" | "info" | "success" | "warning";
export interface Props {
  body: string | ReactNode;
  description?: string | ReactNode;
  options?: Parameters<typeof reactToast>[1];
  variant?: ToastVariant;
}

const toastOptionsDefault = {
  autoClose: 5000,
  closeButton: false,
  closeOnClick: true,
  hideProgressBar: true,
  position: "top-right" as ToastPosition,
};

export default function toast({
  body,
  description,
  options,
  variant = "default",
}: Props): Id {
  const customToastOptions = {
    ...toastOptionsDefault,
    ...(options || {}),
  };

  const toastContent = (props: { closeToast?: () => void }) => (
    <CustomToast
      {...props}
      title={body}
      description={description}
      variant={variant}
    />
  );

  return reactToast(toastContent, {
    className: "p-0 max-w-fit contents",
    ...customToastOptions,
  });
}

export function toastClearWaitingQueue() {
  reactToast.clearWaitingQueue();
}

export function ToastContainer({ limit }: { limit?: number }) {
  return (
    <ReactToastContainer
      closeButton={CloseButton}
      stacked
      {...(limit ? { limit } : {})}
    />
  );
}

export function CloseButton() {
  return (
    <span className={s.closeButton}>
      <CrossIcon color={tokens.colors["neutral"][700]} size={10} />
    </span>
  );
}
